import { LearnerNavRouteStaticDataType, NAV_ROUTE_KEY_TYPE } from './types';
import { NAVIGATION_LEARNER_ICON_LIST } from './constants';
import { NAVIGATION_LEARNER_MENU_LIST } from './enums';
import { SUB_LEARNER_MENU_REGEX_MAP } from './regex';
import { BE_NAVIGATION_DATA_TYPE } from '../../types';

const transformLearnerNavigationData = (
  navData: BE_NAVIGATION_DATA_TYPE[]
): LearnerNavRouteStaticDataType[] =>
  navData
    .filter(item => item.name)
    .map(item => ({
      id: item.id as NAVIGATION_LEARNER_MENU_LIST,
      name: item.name,
      linkPattern: item.linkPattern,
      icon: NAVIGATION_LEARNER_ICON_LIST[item.id],
      permissionsMap: item?.permissionsMap ?? [],
      subMenu: Array.isArray(item.subMenu)
        ? item.subMenu.map(({ id, name, link, showAfterPermissionsCheck = false }) => ({
            id: id as NAV_ROUTE_KEY_TYPE,
            name,
            link,
            showAfterPermissionsCheck,
            subLinkPattern:
              SUB_LEARNER_MENU_REGEX_MAP[id as keyof typeof SUB_LEARNER_MENU_REGEX_MAP],
          }))
        : [],
    }));

export default transformLearnerNavigationData;
